"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validators = void 0;
var _ = __importStar(require("lodash"));
/**
 * Checks if a mandatory value isn't null/undefined/empty , returns {required:true} if error, return null if it's not null/undefined/empty
 * @param value Value to test
 */
var Required = function (value) {
    if (isEmptyValue(value)) {
        return Promise.resolve({ required: true });
    }
    return Promise.resolve(null);
};
/**
 * Checks if a provided value has the minimum length, returns {minlength:true} if error, return null if value has the minimum length
 * @param value Value to test
 */
var MinLength = function (minlength) {
    if (minlength === 0) {
        console.warn('Validator minlength can not be 0, use the required Validator instead');
    }
    return function (value) {
        if (value && (minlength <= value.length || Object.getPrototypeOf(value) === Object.prototype)) {
            return Promise.resolve(null);
        }
        return Promise.resolve({ minlength: true });
    };
};
/**
 * Checks if a provided value has the maxLength
 * return { maxLength: true } when value is bigger maxLenght
 * return null when value is valid.
 * @param value Value to test
 */
var MaxLength = function (maxLength) {
    if (maxLength === 0) {
        throw 'Validator maxLength can not be 0';
    }
    return function (value) {
        if (!value || maxLength >= value.length || Object.getPrototypeOf(value) === Object.prototype) {
            return Promise.resolve(null);
        }
        return Promise.resolve({ maxLength: true });
    };
};
/**
 * Checks if a provided value is a number , returns {number:true} if not a number, return null if number
 * @param value Value to test
 */
var Number = function (value) {
    if (isNaN(value)) {
        return Promise.resolve({ number: true });
    }
    return Promise.resolve(null);
};
/**
 * Checks if a provided value is greater than a min value, returns {minValue:true} if too smaller.
 * @param value Value to test
 */
var MinValue = function (minValue) {
    return function (value) {
        if (isNaN(value) || value < minValue) {
            return Promise.resolve({ minValue: true });
        }
        return Promise.resolve(null);
    };
};
/**
 * Factory that returns a validator to test if value matches the provided pattern
 * Return {pattern:true} if no match,
 * @param value Value to test
 */
var Pattern = function (regex) {
    return function (value) {
        if (new RegExp(regex).test(value)) {
            return Promise.resolve(null);
        }
        return Promise.resolve({ pattern: true });
    };
};
var Email = function (value) {
    // if the value is empty, we don't return any error of email format
    // -> Use Required validator if you want to block empty value
    if (!value) {
        return Promise.resolve(null);
    }
    if (typeof value === 'string') {
        var match = value === null || value === void 0 ? void 0 : value.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g);
        if (!match) {
            return Promise.resolve({ email: true });
        }
    }
    return Promise.resolve(null);
};
var Url = function (value) {
    // if the value is empty, we don't return any error of email format
    // -> Use Required validator if you want to block empty value
    if (!value) {
        return Promise.resolve(null);
    }
    if (typeof value === 'string') {
        try {
            new URL(value);
        }
        catch (_a) {
            return Promise.resolve({ url: true });
        }
    }
    return Promise.resolve(null);
};
var isEmptyValue = function (value) {
    return ((_.isArray(value) || _.isPlainObject(value)) && _.isEmpty(value)) ||
        _.isNil(value) ||
        (_.isString(value) && value.trim() === '');
};
exports.Validators = {
    Url: Url,
    Email: Email,
    Required: Required,
    MinValue: MinValue,
    MinLength: MinLength,
    Number: Number,
    Pattern: Pattern,
    MaxLength: MaxLength,
};
